import ApiService from "./apiService";

class Auth {
   
    static async login(emailAddress: string, password: string) {
        return ApiService.axiosApi('/auth/login', {
            method: 'POST',
            data: { emailAddress, password },
        });
    }
    
    static async register(data: {
        UserName: string;
        Password: string;
        Email: string;
        PhoneNumber: string;
        Roles: string[];
    }) {
        return ApiService.axiosApi('/auth/register', {
            method: 'POST',
            data: data
        });
    }
}

export default Auth;    
